import { forwardRef } from 'react';

import { Link, Typography } from '@mui/material';

import type { UnresolvedIncident } from 'api/types';
import { formatDate } from 'shared/lib/datetime/formatDate';

const getMaintenanceText = (incident: UnresolvedIncident) => {
  const { scheduled_for, scheduled_until, created_at } = incident;

  if (scheduled_for && scheduled_until) {
    return `Planned maintenance is in progress. Possible performance degradation between ${formatDate(scheduled_for, false, 'h:mm a')} and ${formatDate(scheduled_until, false, 'h:mm a')}.`;
  }

  return `Incident investigation is in progress. Possible performance degradation since ${formatDate(created_at, false, 'h:mm a')}`;
};

export const StatusPageInfo = forwardRef<HTMLDivElement, { incident: UnresolvedIncident }>(({ incident }, ref) => {
  const { shortlink } = incident;
  return (
    <div ref={ref} className="w-full relative bg-primary-main flex justify-center z-50">
      <Typography className="text-white py-2 px-6 flex items-center gap-2">
        {getMaintenanceText(incident)}
        <Link className="text-white underline hover:text-white/80 text-nowrap" href={shortlink} target="_blank">
          See details
        </Link>
      </Typography>
    </div>
  );
});
